<template>
  <div v-show="isShow" class="header">
    <div class="left">
      <img class="logo" src="@/assets/img/logo.png">
      <div v-show="showSet" class="text" @click="router.push('/admin/set')">设置</div>
    </div>
    <div class="right">
      <van-popover
        v-model:show="showPopover"
        theme="dark"
        :teleport="element"
        :show-arrow="false"
        :actions="actions"
        @select="onSelect"
      >
        <template #reference>
          <div class="lang">
            <img class="icon" src="@/assets/img/icon_lang.png">
          </div>
        </template>
      </van-popover>
      <div class="wallet">
        <img class="icon" src="@/assets/img/icon_wallet.png">
        <div class="text">{{ getEllipsis(address, '***', 3, 3) }}</div>
      </div>
    </div>
  </div>
  <div v-show="isShow" class="block"></div>

  <!--绑定上级-->
  <van-popup
    v-model:show="show"
    :close-on-click-overlay="false"
  >
    <div class="bind">
      <div class="title">{{ $t('a0') }}</div>
      <textarea v-model="pAddr" rows="2" :placeholder="$t('a1')"></textarea>
      <div class="btn" @click="handleBind">{{ $t('a2') }}</div>
    </div>
  </van-popup>

  <!--下载弹框-->
  <van-popup
    v-model:show="show1"
    closeable
  >
    <div class="download">
      <img src="@/assets/img/layer.jpg">
      <a href="https://www.uxuy.com/join/fage" class="btn"></a>
    </div>
  </van-popup>
</template>

<script setup>
  import { ref, onMounted } from 'vue'
  import { getEllipsis } from '@/utils'
  import { showToast, showLoadingToast, showSuccessToast, showFailToast } from 'vant'
  import { useRoute, useRouter } from "vue-router";
  import { getConfig } from '@/api'
  import { useI18n } from "vue-i18n"

  const { t, locale } = useI18n()
  const Web3Modal = window.Web3Modal.default;
  const WalletConnectProvider = window.WalletConnectProvider.default;

  // Web3modal instance
  let web3Modal, network, provider, selectedAccount, provider1, gasPrice, signer, usdtContract,
  conContract, nodeContract, poolContract, staContract, lpContract, nftContract, bnbBalance, nxContract;
  let injectedWeb3 = null;
  const infura_key = 'c3e254116c559ae5e58746e69fb38787';

  const show = ref(false)
  const showPopover = ref(false)
  const emits = defineEmits(['getSigner'])
  const pAddr = ref('')
  const route = useRoute()
  const router = useRouter()
  const admin = sessionStorage.getItem('admin') || route.query.admin
  const { user } = route.query
  if(admin && user) {
    sessionStorage.setItem('admin', admin)
    sessionStorage.setItem('address', user)
  }
  const address = ref(sessionStorage.getItem('address') || '')
  const showSet = ref(false)
  let admin1 = ''

  onMounted(() => {
    if(!(admin && address.value)) {
      init()
    }
  })

  defineProps({
    isShow: {
      type: Boolean,
      default: true
    }
  })

  const element = document.querySelector('.header')

  const lang = localStorage.getItem('lang') || 'zh'
  const actions = [
    { text: '中文', value: 'zh' },
    { text: 'English', value: 'en' },
    { text: '日本語', value: 'rw' },
    { text: '한국인', value: 'hw' }
  ]

  actions.forEach(item => {
    if(item.value === lang) {
      item.className = 'active'
    } else {
      item.className = ''
    }
  })
  function onSelect(obj) {
    locale.value = obj.value
    actions.forEach(item => {
      if(item.value === obj.value) {
        item.className = 'active'
      } else {
        item.className = ''
      }
    })
    localStorage.setItem('lang', obj.value)
  }

  const show1 = ref(false)
  /*show1.value = !sessionStorage.getItem('read');
  function handleClose() {
    show1.value = false
    sessionStorage.setItem('read', '1')
  }*/
  async function init() {
    const providerOptions = {
      walletconnect: {
        package: WalletConnectProvider,
        options: {
          bridge: "https://uniswap.bridge.walletconnect.org",
          rpc: {
            56: 'https://bsc-dataseed.binance.org/',
            66: 'https://exchainrpc.okex.org',
            97: 'https://data-seed-prebsc-1-s3.binance.org:8545/',
            137: 'https://polygon-rpc.com/',
          },
          // Mikko's test key - don't copy as your mileage may vary
          infuraId: infura_key,
        }
      },
    };
    web3Modal = new Web3Modal({
      cacheProvider: false, // optional
      providerOptions, // required
      disableInjectedProvider: false, // optional. For MetaMask / Brave / Opera.
    });
    try {
      provider = await web3Modal.connect();
      provider.enable()
    } catch (e) {
      console.log("Could not get a wallet connection", e);
      alert("cannot connect wallet");
      return;
    }
    // Subscribe to accounts change
    provider.on("accountsChanged", async (accounts) => {
      await fetchAccountData();
    });
    // Subscribe to chainId change
    provider.on("chainChanged", async (chainId) => {
      await fetchAccountData();
    });
    // Subscribe to networkId change
    provider.on("networkChanged", async (networkId) => {
      await fetchAccountData();
    });
    provider.on("disconnect", async (code, reason) => {
      console.log(code, reason);
      await onDisconnect();
    });
    await fetchAccountData(provider);
  }

  async function fetchAccountData() {
    const web3 = new Web3(provider);
    injectedWeb3 = web3;
    const accounts = await web3.eth.getAccounts();
    selectedAccount = accounts[0];
    network = await web3.eth.net.getId();
    console.log(network + ': ' + selectedAccount);
    if (network != 56) {
      showToast(t('a3'))
      await onDisconnect();
    } else {
      provider1 = new ethers.providers.Web3Provider(web3.currentProvider);
      signer = provider1.getSigner();
      address.value = selectedAccount;
      conContract = new ethers.Contract(contractConfig.conAddress, conAbi, signer);
      getConfig().then(async res => {
        if(res.success) {
          admin1 = res.data.set_address
          if(address.value === admin1) {
            showSet.value = true
            return
          }
          const addr = await conContract.getReferrer(address.value)
          if(addr === '0x0000000000000000000000000000000000000000' && address.value !== '0x9ae7ABc35b2d23b936780D24fd3977e645C09D2C') {
            show.value = true
          }
        }
      })
      gasPrice = await web3.eth.getGasPrice();
      poolContract = new ethers.Contract(contractConfig.poolAddress, poolAbi, signer);
      usdtContract = new ethers.Contract(contractConfig.usdtAddress, usdtAbi, signer);
      staContract = new ethers.Contract(contractConfig.staAddress, staAbi, signer);
      nodeContract = new ethers.Contract(contractConfig.nodeAddress, nodeAbi, signer);
      lpContract = new ethers.Contract(contractConfig.lpAddress, lpAbi, signer);
      nftContract = new ethers.Contract(contractConfig.nftAddress, nftAbi, signer);
      nxContract = new ethers.Contract(contractConfig.nxAddress, nxAbi, signer);
      sessionStorage.setItem('address', selectedAccount)
      const weiBalance = await web3.eth.getBalance(selectedAccount);
      bnbBalance = web3.utils.fromWei(weiBalance, "ether");
      toContinue()
    }
  }

  async function toContinue() {
    emits('getSigner', {
      address: address.value,
      poolContract,
      nodeContract,
      usdtContract,
      staContract,
      conContract,
      lpContract,
      nftContract,
      gasPrice,
      bnbBalance,
      nxContract,
      provider: provider1
    })
    if(route.query.p_address) {
      pAddr.value = route.query.p_address
    }
  }

  async function handleBind() {
     if(pAddr.value === '') {
      showToast(t('a1'))
      return
    }
    if(pAddr.value.substring(0, 2) !== '0x' || pAddr.value.length !== 42) {
      showToast(t('a4'))
      return
    }
    showLoadingToast({
      message: t('a5'),
      forbidClick: true,
      duration: 0
    })
    try {
      const res = await conContract.bindReferrer(pAddr.value)
      if(res) {
        showSuccessToast(t('a6'))
        show.value = false
      } else {
        console.log(res)
      }
    } catch (e) {
      showFailToast(t('a7'))
    }
  }

  async function onDisconnect() {
    console.log("Killing the wallet connection", provider);
    // TODO: Which providers have close method?
    if (address.value) {
      await web3Modal.clearCachedProvider();
      await provider.disconnect()
      provider = null;
      selectedAccount = null;
      address.value = '';
    }
  }
</script>

<style scoped lang="less">
.header{
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  height: 54px;
  background: #000000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px;
  border-bottom: 0.5px solid #414141;
  z-index: 99;

  .left{
    display: flex;
    align-items: center;

    .logo{
      width: 33px;
      margin-right: 2px;
    }
    .text{
      font-size: 14px;
      margin-left: 12px;
    }
  }
  .right{
    display: flex;

    .lang{
      height: 33px;
      background: rgba(218, 78, 53, 0.15);
      border-radius: 6px;
      display: flex;
      align-items: center;
      padding: 0 10px;

      .icon{
        width: 16px;
      }
      .arrow{
        width: 9px;
        margin-left: 4px;
      }
    }
    .wallet{
      height: 33px;
      background: rgba(218, 78, 53, 0.15);
      border-radius: 6px;
      display: flex;
      align-items: center;
      padding: 0 10px;
      margin-left: 6px;

      .icon{
        width: 19px;
        margin-right: 6px;
      }
      .text{
        font-size: 13px;
      }
    }
  }
}
.block{
  height: 54px;
}
.bind{
  width: 309px;
  height: 235px;
  background: url("@/assets/img/bindBg.png") no-repeat;
  background-size: 100% 100%;
  padding: 24px 22px 0 22px;

  .title{
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    line-height: 24px;
    margin-bottom: 32px;
  }
  .btn{
    width: 115px;
    height: 35px;
    margin: 28px auto 0 auto;
  }
}
.van-popup{
  background: transparent;
}
:deep(.van-popover--dark){
  .van-popover__content{
    background: #000000;
    border: 1px solid rgba(218, 78, 53,0.2);
  }
  .van-popover__action{
    width: 100px;
    height: 36px;
  }
  .van-popover__action:active{
    background-color: transparent;
    color: #DA4E35;
  }
  .van-popover__action-text:after{
    border-color: rgba(218, 78, 53,0.3);
  }
  .van-popover__action.active{
    color: #DA4E35;
  }
}
.download{
  width: 309px;
  position: relative;

  img{
    width: 100%;
    border-radius: 12px;
  }
  .btn{
    display: block;
    width: 180px;
    height: 34px;
    position: absolute;
    background: transparent;
    left: 50%;
    transform: translateX(-50%);
    bottom: 15px;
  }
}
:deep(.van-popup__close-icon){
  color: #000000;
}
:deep(.van-popup__close-icon--top-right) {
  top: 10px;
  right: 10px;
}
</style>
